import { type NexusApiActionDef } from "./action-def.types";
import { deleteOutput, listOutput, obj } from "./output-format.builders";

export const agentActions: NexusApiActionDef[] = [
  {
    action: "agents.list",
    label: "List Agents",
    description: "List all agents in the organization",
    inputSchema: {},
    outputFormat: listOutput("agents")
  },
  {
    action: "agents.get",
    label: "Get Agent",
    description: "Get agent details by ID",
    inputSchema: {
      agentId: { type: "string", description: "Agent ID" }
    },
    outputFormat: obj("Agent details")
  },
  {
    action: "agents.create",
    label: "Create Agent",
    description: "Create a new agent",
    inputSchema: {
      firstName: { type: "string", description: "First name" },
      lastName: { type: "string", description: "Last name" },
      role: { type: "string", description: "Agent role / system prompt" }
    },
    outputFormat: obj("Created agent")
  },
  {
    action: "agents.update",
    label: "Update Agent",
    description: "Update an existing agent",
    inputSchema: {
      agentId: { type: "string", description: "Agent ID" },
      firstName: { type: "string", description: "First name (optional)" },
      lastName: { type: "string", description: "Last name (optional)" },
      role: { type: "string", description: "Agent role (optional)" }
    },
    outputFormat: obj("Updated agent")
  },
  {
    action: "agents.delete",
    label: "Delete Agent",
    description: "Delete an agent",
    inputSchema: {
      agentId: { type: "string", description: "Agent ID" }
    },
    outputFormat: deleteOutput
  },
  {
    action: "agents.duplicate",
    label: "Duplicate Agent",
    description: "Duplicate an existing agent",
    inputSchema: {
      agentId: { type: "string", description: "Agent ID to duplicate" }
    },
    outputFormat: obj("Duplicated agent")
  }
];
